import React from "react";
import "./AboutHeroSection.css";



const AboutHeroSection = () => {
  return (
    <section className="about-hero">
      <div className="about-hero-overlay"></div>
      <div className="about-hero-content">
        <h1 className="about-hero-heading">
          Empowering <span>Freshers</span> to Build Careers,
          <br /> Not Just Get Jobs.
        </h1>
        <p className="about-hero-subtext">
          At <strong>MBR Network’s</strong>, we’re redefining how freshers and
          job seekers shape their careers. Founded by{" "}
          <span className="founder-name">Bharath Reddy</span> — a passionate
          professional with
          <strong> 5+ years of experience</strong> in{" "}
          <em>Software Development, Business Development,</em> and
          <em> Business Analysis</em>, we bring industry insight and real-world
          strategies to help you{" "}
          <span className="highlight">grow confidently, get noticed,</span> and
          <span className="highlight"> land your dream role.</span>
        </p>
        <div className="about-hero-cta">
          <a href="#mission" className="btn btn-primary">
            Explore Our Mission
          </a>
          <a href="#contact" className="btn btn-outline">
            Join the Network
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutHeroSection;
